import { fetchPost } from "../../../../../common/util/fetch";

export async function fetchSetMuteStatus(
    fromUserId: number,
    targetUserId: number,
    muted: boolean
): Promise<boolean> {
    const result = await fetchPost<
        {
            fromUserId: number;
            targetUserId: number;
            muted: boolean;
        },
        boolean
    >("api/Message/SetMuteStatus", { fromUserId, targetUserId, muted });
    if (typeof result === "boolean") {
        return result;
    }
    return false;
}

